




























































import AppraisalForm from "@/components/appraisal/AppraisalForm.vue";
import CompanySheet from "@/components/company/CompanySheet.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";
import { Reference } from "@/models/reference.entity";
import { SignDocument } from "@/models/sign-document.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent, LineItemsForm, DropAreaMulti, AppraisalForm },
  filters: {}
})
export default class ReportAppraisalCreateDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly formatCurrency = formatCurrency;
  readonly CurrencyEnum = CurrencyEnum;
  readonly TotalLossType = TotalLossType;

  isValid = false;

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.reset();
    }
    this.dialog = val;

    if (!val) {
      this.reset();
    }
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("file")
  setEstimateNumber() {
    if (!this.appraisal.title && this.file) {
      if (this.file.name?.endsWith(".pdf")) {
        this.appraisal.title = this.file.name.substring(0, this.file.name.length - 4);

        return;
      }
      this.appraisal.title = this.file.name;

      return;
    }
  }

  appraisal: IAppraisal = new Appraisal({});

  requestsLoading = false;

  file: File | null = null;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get context() {
    return {
      appraisal: this.appraisal,
      partner: this.partner,
      report: this.report
    };
  }

  get validForm() {
    return this.report.appraiserCompanyId && this.isValid;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async create() {
    this.requestsLoading = true;

    if (!this.report.appraiserCompanyId) {
      throw new Error("Appraise company ID is not defined in the report");
    }

    if (!this.report.appraiserCompany) {
      await this.report.fetchAppraiserEntity();
    }

    if (!this.report.appraiserCompany) {
      throw new Error("Error loading appraise entity");
    }

    try {
      const refs = [];
      refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));
      if (this.report.vehicleId) {
        refs.push(new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE }));
      }

      this.appraisal.reportId = this.report.id;
      this.appraisal.partnerId = this.report.partnerId;
      this.appraisal.seller = this.report.appraiserCompany.invoiceParty;
      this.appraisal.refs = refs;
      this.appraisal.subTotal = this.appraisal.lineItems[0]?.amount || 0;

      if (this.myUserId) {
        this.appraisal.assignees = [this.myUserId];
      }

      const appraisal = await this.appraisal.create();

      refs.push(new Reference({ refId: appraisal.id, refType: ResourceEnum.APPRAISAL }));

      if (this.file) {
        const signDocument = new SignDocument({
          name: this.file.name,
          title: this.file.name,
          isTemplate: false,
          folder: "/appraisal/",
          refs: refs,
          file: this.file,
          partnerId: this.partner.id
        });

        await signDocument.create();

        await this.appraisal.updatePartial({
          documentId: signDocument.id,
          status: RequestStatusEnum.REPLIED
        });
        this.appraisal.document = signDocument;
      }

      this.report.appraisals.unshift(this.appraisal);
    } catch (e) {
      handleError(e);
    } finally {
      this.close();
      this.requestsLoading = false;
    }

    return {
      appraisal: this.appraisal
    };
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  reset() {
    this.file = null;
    this.appraisal = new Appraisal({
      partnerId: this.partner.id
    });
    this.appraisal.setDefaultLineItems();
  }
}
